import React from 'react';
import { steps } from '../data/spremna';
export function HowItWorks() {
  return <section className="w-full border-y border-slate-900/10 bg-stone-100 px-8 py-24 sm:px-14 sm:py-32" data-id="element-175" data-mp="7svdaescvutl">
      <div className="mx-auto max-w-6xl" data-id="element-176" data-mp="3pyrp50ha6wc5">
        <div className="grid gap-8 lg:grid-cols-12 lg:items-end" data-id="element-177" data-mp="3pzt8rtcd4r5h">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl lg:col-span-7" data-id="element-178" data-mp="3tzjydtq5l18f">
            Како функционише <em className="text-red-700" style={{
            hyphens: 'manual'
          }} data-id="element-179" data-mp="lktfs6rkasgs">МАТЕМАТИКА СПРЕМНА™</em>
          </h2>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-5" data-id="element-180" data-mp="qilcrf72d4ru">
            Од преузимања до учионице: припремите следећи час за само пет минута.
          </p>
        </div>

        <ol className="mt-16 grid gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8" data-id="element-181" data-mp="grqn00ulzn1n">
          {steps.map((step, index) => <li key={step.title} className="relative border-t-2 border-slate-900 pt-6" data-id="element-182" data-mp="14h1esstze73n" data-mpi={index}>
              <span className="font-serif text-5xl italic leading-none text-red-700" aria-hidden="true" data-id="element-183" data-mp="19b5mxfezgl6b">
                {index + 1}
              </span>
              <h3 className="mt-4 font-serif text-2xl leading-tight text-slate-900" data-id="element-184" data-mp="2mn35u0r8r9ki">
                <span className="sr-only" data-id="element-185" data-mp="31b7jgqbfsuwf">Корак {index + 1}: </span>
                {step.title}
              </h3>
              <p className="mt-2 leading-relaxed text-slate-900/70" data-id="element-186" data-mp="2wkhcj8nd4jzm">{step.text}</p>
            </li>)}
        </ol>

        <p className="mt-16 text-center font-serif text-2xl italic leading-snug text-slate-900/80 sm:text-3xl" data-id="element-187" data-mp="3ab4dl7glilyv">
          Отворите → изаберите → припремите → предајте. Једноставно и прегледно.
        </p>
      </div>
    </section>;
}